import './Game.css';
import Game from './Game';
export default Game;



// WEBPACK FOOTER //
// ./src/components/Game/index.js